import { render } from "./subTitle.vue?vue&type=template&id=a025f85c"
import script from "./subTitle.vue?vue&type=script&lang=js"
export * from "./subTitle.vue?vue&type=script&lang=js"

import "./subTitle.vue?vue&type=style&index=0&id=a025f85c&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__